/* hs-eslint ignored failing-rules */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom';
import userInfo from 'hub-http/userInfo';
import PortalIdParser from 'PortalIdParser'; // Redux

import { Provider } from 'react-redux';
import configureStore from './utils/configureStore'; // Configure the router

import { BrowserRouter } from 'react-router-dom';
import routes from './Routes';
import { getRootUrl } from './utils/urls';
import { fromJS } from 'immutable';
import ContentRoutes from 'ContentUtils/Routes';
import Raven from 'raven-js';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import UIApplication from 'UIComponents/app/UIApplication';
import PortalScopesApi from './api/PortalScopes'; // Imports all currency data
// Needed if you render currency anywhere (such as reports)

import 'I18n/init/data/currency';
export default class Application {
  // Kicks off the app. This is intentionally not in the constructor just in
  // case there is a reason you need to explicitly call init (and don't want it
  // auto-called by importing this module)
  start() {
    if (window.jasmine) return;
    window.AppInstance = this;
    const I18nProvider = createStandardI18nProvider();
    const langAvailable = initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    this.init().then(([{
      gates,
      portal,
      user
    }, portalScopes]) => {
      I18nProvider.setLocale({
        langEnabled: user.lang_enabled,
        locale: user.locale,
        timezone: portal.timezone
      });
      ContentRoutes.init(gates);
      this.store = configureStore({
        auth: fromJS({
          gates,
          portal,
          portalScopes: portalScopes.scopes,
          user
        })
      });
      Raven.setUserContext({
        email: user.email,
        id: user.user_id,
        locale: user.locale
      });
      return langAvailable.then(() => this.startRouter());
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  } // Performs all the initialization needed before the main app code can run/render.


  init() {
    // Kick off the auth process
    // Sets hubspot.portal.id (unless `{ preserveGlobalId: true }` was passed)
    PortalIdParser.get(); // Return a promise that is resolved when every promise in Auth initializers
    // and I18n has resolved. AKA, when everything is ready.

    return Promise.all([userInfo(), PortalScopesApi.fetchPortalScopes()]);
  }

  startRouter() {
    render( /*#__PURE__*/_jsx(UIApplication, {
      name: "content-detail-ui",
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(BrowserRouter, {
          basename: getRootUrl(),
          children: routes
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }

}